export default class WizardBatchGroupObject {

  static _createRepeatingBatchGroupObject(batchGroupForm) {

    console.log("batchgroupform on repeating", batchGroupForm);
      //check if end time input is correct and/or add the : to the time
    if (
        batchGroupForm.StartTime.length != 4 ||
        batchGroupForm.StartTime.charAt(0) > "2" ||
         (batchGroupForm.StartTime.charAt(0) == "2" && batchGroupForm.StartTime.charAt(1) >= "4") ||
        batchGroupForm.StartTime >= batchGroupForm.EndTime
      ) {
        window.EventBus.fire("inputDialog");
        return null;
      }
      if (
        batchGroupForm.StartTime.charAt(2) == "6" ||
        batchGroupForm.StartTime.charAt(2) == "7" ||
        batchGroupForm.StartTime.charAt(2) == "8" ||
        batchGroupForm.StartTime.charAt(2) == "9" ||
        batchGroupForm.StartTime.length > 5
      ) {
        window.EventBus.fire("inputDialog");
        return null;
      }

      if (batchGroupForm.StartTime.charAt(2) !== ":") {
        batchGroupForm.StartTime =
          batchGroupForm.StartTime.slice(0, 2) +
          ":" +
          batchGroupForm.StartTime.slice(2, 4);
      }

      //check if end time input is correct and/or add the : to the time
      if (
        batchGroupForm.EndTime.length != 4 ||
        batchGroupForm.EndTime.charAt(0) > "2" ||
         (batchGroupForm.EndTime.charAt(0) == "2" && batchGroupForm.EndTime.charAt(1) >= "4")
      ) {
        window.EventBus.fire("inputDialog");
        return null;
      }
      if (
        batchGroupForm.EndTime.charAt(2) == "6" ||
        batchGroupForm.EndTime.charAt(2) == "7" ||
        batchGroupForm.EndTime.charAt(2) == "8" ||
        batchGroupForm.EndTime.charAt(2) == "9" ||
        batchGroupForm.EndTime.length > 5
      ) {
        window.EventBus.fire("inputDialog");
        return null;
      }

      if (batchGroupForm.EndTime.charAt(2) !== ":") {
        batchGroupForm.EndTime =
          batchGroupForm.EndTime.slice(0, 2) +
          ":" +
          batchGroupForm.EndTime.slice(2, 4);
      }


    let parseDates = {};
    batchGroupForm.Days.forEach(function(element) {
      parseDates[element] = element;
    });
    console.log("batchgroupform before the date changes", batchGroupForm)
    batchGroupForm.EndDate = new Date(batchGroupForm.EndDate)
     .toLocaleDateString("nl-NL")
     .split("/")
     .join("-");
    batchGroupForm.StartDate = new Date(batchGroupForm.StartDate)
     .toLocaleDateString("nl-NL")
     .split("/")
     .join("-");

    let requestObject = {
      EventId: batchGroupForm.EventId,
      LocationId: batchGroupForm.LocationId,
      Name: batchGroupForm.Name,
      StartTime: batchGroupForm.StartTime,
      EndTime: batchGroupForm.EndTime,
      Price: Number(batchGroupForm.Price).toFixed(2),
      RatePrice: Number(batchGroupForm.RatePrice).toFixed(2),
      RewardPoints: Number(batchGroupForm.RewardPoints),
      FlexPercentage: 0,
      NrOfRegistrations: 0,
      Type: "Repeating",
      StartDate: batchGroupForm.StartDate,
      EndDate: batchGroupForm.EndDate,
      Days: parseDates,
      PriceCategories: batchGroupForm.PriceCategories,
      BookingPolicy: Number(batchGroupForm.BookingPolicy),
    };
    if (batchGroupForm.BatchFrequency !== 0) {
      requestObject.BatchFrequency = Number(batchGroupForm.BatchFrequency) * 60;
      requestObject.MaxInflow = Number(batchGroupForm.MaxInflow);
    } else {
        requestObject.BatchFrequency = Number(batchGroupForm.BatchFrequency);
        requestObject.MaxInflow = Number(batchGroupForm.MaxInflow);
        console.log("batchgroupform", requestObject)
    }
    return requestObject;
  }

  static _createSpecificBatchGroupObject(batchGroupForm) {
      console.log("batchgroupform on specific", batchGroupForm);
    
    //check if end time input is correct and/or add the : to the time
       if (
        batchGroupForm.StartTime.length != 4 ||
        batchGroupForm.StartTime.charAt(0) > "2" ||
         (batchGroupForm.StartTime.charAt(0) == "2" && batchGroupForm.StartTime.charAt(1) >= "4") ||
        batchGroupForm.StartTime >= batchGroupForm.EndTime
      ) {
        window.EventBus.fire("inputDialog");
        return null;
      }
      if (
        batchGroupForm.StartTime.charAt(2) == "6" ||
        batchGroupForm.StartTime.charAt(2) == "7" ||
        batchGroupForm.StartTime.charAt(2) == "8" ||
        batchGroupForm.StartTime.charAt(2) == "9" ||
        batchGroupForm.StartTime.length > 5
      ) {
        window.EventBus.fire("inputDialog");
        return null;
      }

      if (batchGroupForm.StartTime.charAt(2) !== ":") {
        batchGroupForm.StartTime =
          batchGroupForm.StartTime.slice(0, 2) +
          ":" +
          batchGroupForm.StartTime.slice(2, 4);
      }

    //check if end time input is correct and/or add the : to the time
      if (
        batchGroupForm.EndTime.length != 4 ||
        batchGroupForm.EndTime.charAt(0) > "2" ||
         (batchGroupForm.EndTime.charAt(0) == "2" && batchGroupForm.EndTime.charAt(1) >= "4")
      ) {
        window.EventBus.fire("inputDialog");
        return null;
      }
      if (
        batchGroupForm.EndTime.charAt(2) == "6" ||
        batchGroupForm.EndTime.charAt(2) == "7" ||
        batchGroupForm.EndTime.charAt(2) == "8" ||
        batchGroupForm.EndTime.charAt(2) == "9" ||
        batchGroupForm.EndTime.length > 5
      ) {
        window.EventBus.fire("inputDialog");
        return null;
      }

      if (batchGroupForm.EndTime.charAt(2) !== ":") {
        batchGroupForm.EndTime =
          batchGroupForm.EndTime.slice(0, 2) +
          ":" +
          batchGroupForm.EndTime.slice(2, 4);
      }
     
    let parseSelectedDates = {};
    batchGroupForm.Dates.forEach(function(element) {
      let correctDate = new Date(element).toLocaleDateString("nl-NL").split('/').join('-');
      parseSelectedDates[correctDate] = correctDate;
    });
    let requestObject = {
      EventId: batchGroupForm.EventId,
      LocationId: batchGroupForm.LocationId,
      Name: batchGroupForm.Name,
      StartTime: batchGroupForm.StartTime,
      EndTime: batchGroupForm.EndTime,
      Price: Number(batchGroupForm.Price).toFixed(2),
      RatePrice: Number(batchGroupForm.RatePrice).toFixed(2),
      RewardPoints: Number(batchGroupForm.RewardPoints),
      FlexPercentage: 0,
      NrOfRegistrations: 0,
      Type: "Specific",
      Dates: parseSelectedDates,
      PriceCategories: batchGroupForm.PriceCategories,
      BookingPolicy: Number(batchGroupForm.BookingPolicy)
    };

    if (batchGroupForm.BatchFrequency !== 0) {
        requestObject.BatchFrequency = Number(batchGroupForm.BatchFrequency) * 60;
        requestObject.MaxInflow = Number(batchGroupForm.MaxInflow);
      } else {
          requestObject.BatchFrequency = Number(batchGroupForm.BatchFrequency);
          requestObject.MaxInflow = Number(batchGroupForm.MaxInflow);
          console.log("batchgroupform", requestObject)
      }

    return requestObject;
  }
  static _deleteRequestBatchgroup(object) {
    let reqObj = {
        BatchGroupId: Number(object.BatchGroupId),
        Type: object.Type,
    };
    return reqObj;
  }
}
